import React, { lazy, Suspense, useState } from "react";
import { Drawer, Typography, Collapse, Modal, List } from "antd";
import {
    FileTextOutlined,
    ApartmentOutlined,
    TeamOutlined,
    NotificationOutlined,
    AppstoreOutlined,
    PictureOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { BASE_API } from "../Config/Config";
import { fetchannouncementapi } from "../api/fetchannouncementapi";
import { fetchsliderimagesapi } from "../api/fetchsliderimagesapi"
import { useTranslation } from "react-i18next";

const { Title } = Typography;
const { Panel } = Collapse;

const MoreDrawer = ({ open, onClose }) => {
    const { t } = useTranslation();
    const [activeKey, setActiveKey] = useState(null);
    const [tendersOpen, setTendersOpen] = useState(false);
    const [galleryOpen, setGalleryOpen] = useState(false);
    const [managementTeamOpen, setManagementTeamOpen] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [openSliderModal, setOpenSliderModal] = useState(false);

    const [data, setData] = useState([]);

    const [loading, setLoading] = useState(null);
    const [editIndex, setEditIndex] = useState(null);
    const [editData, setEditData] = useState({ ta_news: "", en_news: "" });
    const [isAdding, setIsAdding] = useState(false);

    const [uploadedImages, setUploadedImages] = useState([]);
    const [previewImage, setPreviewImage] = useState(null);

    const handleImageUpload = async (e) => {
        const files = Array.from(e.target.files);

        if (!files.length) return;

        try {
            setLoading(true);

            // Get existing slider image numbers
            const existingNumbers = uploadedImages
                .map((img) => {
                    const match = img.title?.match(/Slider Image\s*(\d+)/i);
                    return match ? Number(match[1]) : null;
                })
                .filter((num) => num !== null);

            // Find the first missing number
            const getNextSliderNumber = () => {
                let number = 1;

                while (existingNumbers.includes(number)) {
                    number++;
                }

                existingNumbers.push(number);

                return number;
            };

            // Upload each selected image
            for (const file of files) {
                const sliderNumber = getNextSliderNumber();

                const formData = new FormData();

                formData.append("image", file);
                formData.append("title", `Slider Image ${sliderNumber}`);
                formData.append("status", "active");

                const response = await fetch(
                    `${BASE_API}/apis/addhomeimage.php`,
                    {
                        method: "POST",
                        body: formData,
                        credentials: "include"
                    }
                );

                const result = await response.json();

                if (result.status !== "success") {
                    console.error(
                        "Upload Error:",
                        result.message || "Unknown error"
                    );
                    continue;
                }
            }

            // Refresh slider images
            await handlesliderimages();

            // Reset file input
            e.target.value = "";

        } catch (error) {
            console.error("Upload Error:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteImage = async (img) => {
        try {
            const formData = new FormData();
            formData.append("id", img.id);

            const response = await fetch(
                `${BASE_API}/apis/deletehomeimage.php`,
                {
                    method: "DELETE",
                    body: formData,
                    credentials: "include"
                }
            );

            const result = await response.json();

            if (
                result.status === true
            ) {
                handlesliderimages();
                // window.location.reload();
            } else {
                console.error("Fetch Error:", result.message || "Unknown error");
            }
        } catch (err) {
            console.error("Fetch Error:", "Unknown error");
        }
    };

    const ModifyTendersDrawer = lazy(() => import("./ModifyTendersDrawer"));
    const ModifyGalleryDrawer = lazy(() => import("./ModifyGalleryDrawer"));
    const ManagementTeams = lazy(() => import("./ManagementTeams"));

    const Navigate = useNavigate();

    const Userdetails = JSON.parse(sessionStorage.getItem("userdetails"))

    const cardStyle = {
        padding: "18px",
        borderRadius: "16px",
        background: "linear-gradient(135deg, #f5f7fa, #e4ecff)",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: "14px",
        transition: "all 0.3s ease",
        boxShadow: "0 4px 12px rgba(0,0,0,0.05)"
    };

    const hoverStyle = {
        transform: "translateY(-4px)",
        boxShadow: "0 8px 20px rgba(0,0,0,0.1)"
    };

    const handleannocement = async () => {
        const data = await fetchannouncementapi();
        setData(data);
    }

    const handlesliderimages = async () => {
        const data = await fetchsliderimagesapi();
        setUploadedImages(data);
    }

    const handleEdit = (item, index) => {
        setEditIndex(index);
        setEditData(item);
    };

    const handleSave = async () => {
        if (isAdding) {
            if (!editData?.ta_news && !editData?.en_news) {
                alert("Please enter the announcement text.");
                return;
            }
            try {
                const formData = new FormData();
                formData.append("user_id", Userdetails?.id);
                formData.append("ta_news", editData.ta_news || "");
                formData.append("en_news", editData.en_news || "");

                const response = await fetch(
                    `${BASE_API}/apis/annoceadd.php`,
                    {
                        method: "POST",
                        body: formData,
                        credentials: "include"
                    }
                );

                const result = await response.json();

                if (
                    result.status === "success"
                ) {

                    handleannocement();
                    setIsAdding(false);
                    setEditIndex(null);
                    window.location.reload();

                } else {
                    console.error("Fetch Error:", result.message || "Unknown error");
                }
            } catch (err) {
                console.error("Fetch Error:", "Unknown error");
            }
        } else {
            try {
                const formData = new FormData();
                formData.append("id", editData.id || "");
                formData.append("ta_news", editData.ta_news || "");
                formData.append("en_news", editData.en_news || "");

                const response = await fetch(
                    `${BASE_API}/apis/annoceupdate.php`,
                    {
                        method: "POST",
                        body: formData,
                        credentials: "include",
                    }
                );

                const result = await response.json();

                if (
                    result.status === "success"
                ) {
                    handleannocement();
                    setEditIndex(null);
                    window.location.reload();
                } else {
                    console.error("Fetch Error:", result.message || "Unknown error");
                }
            } catch (err) {
                console.error("Fetch Error:", "Unknown error");
            }
        };
    };

    const handleDelete = async (id) => {
        try {
            const formData = new FormData();
            formData.append("id", id);

            const response = await fetch(
                `${BASE_API}/apis/annocedelete.php`,
                {
                    method: "POST",
                    body: formData,
                    credentials: "include"
                }
            );

            const result = await response.json();

            if (
                result.status === "success"
            ) {
                handleannocement();
                window.location.reload();
            } else {
                console.error("Fetch Error:", result.message || "Unknown error");
            }
        } catch (err) {
            console.error("Fetch Error:", "Unknown error");
        }
    };

    const handleAdd = async () => {
        if (data.length >= 5) return;

        setEditIndex(data.length);   // temporary index
        setEditData({ ta: "", en: "" });
        setIsAdding(true);
    };

    const handleCancel = () => {
        setEditIndex(null);
        setIsAdding(false);
    }

    const handleManagementOrgchart = () => {
        Navigate("/warehouse-Admin/management-org-chart");
    }

    const handleWarehouseOrgchart = () => {
        Navigate("/warehouse-Admin/warehouse-org-chart");
    }

    return (
        <Drawer
            title={<Title level={4} style={{ margin: 0 }}>{t("moreOptions")}</Title>}
            width={500}
            onClose={onClose}
            open={open}
            push={false}
            bodyStyle={{ background: "#f9fafc" }}
        >
            {/* ANNOUNCEMENT */}
            <div
                style={{ ...cardStyle, marginTop: 10, cursor: "pointer" }}
                onClick={() => { setOpenModal(true); handleannocement() }}
                onMouseEnter={e => Object.assign(e.currentTarget.style, hoverStyle)}
                onMouseLeave={e => Object.assign(e.currentTarget.style, cardStyle)}
            >
                <NotificationOutlined style={{ fontSize: 22, color: "#f59e0b" }} />
                <span style={{ fontWeight: 500 }}>{t("announcement")}</span>
            </div>

            {/* slider image change */}
            <div
                style={{ ...cardStyle, marginTop: 10, cursor: "pointer" }}
                onClick={() => { setOpenSliderModal(true); handlesliderimages() }}
                onMouseEnter={e => Object.assign(e.currentTarget.style, hoverStyle)}
                onMouseLeave={e => Object.assign(e.currentTarget.style, cardStyle)}
            >
                <PictureOutlined
                    style={{
                        fontSize: 22,
                        color: "#2563eb"
                    }}
                />
                <span style={{ fontWeight: 500 }}>{t("sliderimages")}</span>
            </div>

            {/* gallery */}
            <div
                style={{ ...cardStyle, marginTop: 10 }}
                onClick={() => setGalleryOpen(true)}
                onMouseEnter={e => Object.assign(e.currentTarget.style, hoverStyle)}
                onMouseLeave={e => Object.assign(e.currentTarget.style, cardStyle)}
            >
                <AppstoreOutlined style={{ fontSize: 22, color: "#4f46e5" }} />
                <span style={{ fontWeight: 500 }} >{t("gallery")}</span>
            </div>

            {/* TENDERS */}
            <div
                style={{ ...cardStyle, marginTop: 10 }}
                onClick={() => setTendersOpen(true)}
                onMouseEnter={e => Object.assign(e.currentTarget.style, hoverStyle)}
                onMouseLeave={e => Object.assign(e.currentTarget.style, cardStyle)}
            >
                <FileTextOutlined style={{ fontSize: 22, color: "#4f46e5" }} />
                <span style={{ fontWeight: 500 }} >{t("tenders")}</span>
            </div>

            {/* MANAGEMENT TEAM IMAGES */}
            <div
                style={{ ...cardStyle, marginTop: 10 }}
                onMouseEnter={e => Object.assign(e.currentTarget.style, hoverStyle)}
                onMouseLeave={e => Object.assign(e.currentTarget.style, cardStyle)}
                onClick={() => setManagementTeamOpen(true)}
            >
                <TeamOutlined style={{ fontSize: 22, color: "#ec4899" }} />
                <span style={{ fontWeight: 500 }}>{t("leadershipTeam")}</span>
            </div>

            {/* ORG CHART */}
            <div style={{ marginTop: 10 }}>
                <Collapse
                    bordered={false}
                    activeKey={activeKey}
                    onChange={(key) => setActiveKey(key)}
                    style={{ background: "#f9fafc" }}
                >
                    <Panel
                        header={
                            <div style={{
                                display: "flex", alignItems: "center", gap: 10,
                                background: "linear-gradient(135deg, #f5f7fa, #e4ecff)",
                            }}>
                                <ApartmentOutlined style={{ color: "#3366cc" }} />
                                <span style={{ fontWeight: 500 }}>{t("orgChart")}</span>
                            </div>
                        }
                        key="1"
                        style={{
                            borderRadius: "16px",
                            background: "linear-gradient(135deg, #f5f7fa, #e4ecff)",
                            border: "none",
                            marginBottom: 10
                        }}
                    >
                        <div style={{ paddingLeft: 10 }}>

                            <div style={{
                                padding: "10px 12px",
                                borderRadius: "10px",
                                cursor: "pointer",
                                transition: "0.3s",
                            }}
                                onClick={handleManagementOrgchart}
                                onMouseEnter={e => Object.assign(e.currentTarget.style, hoverStyle)}
                                onMouseLeave={e => Object.assign(e.currentTarget.style, cardStyle)}

                            // onMouseEnter={(e) => e.currentTarget.style.background = "#4f46e5"}
                            // onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
                            >
                                <TeamOutlined style={{ color: "#3366cc" }} /> {t("managementOrgChart")}
                            </div>

                            <div style={{
                                padding: "10px 12px",
                                borderRadius: "10px",
                                cursor: "pointer",
                                transition: "0.3s",
                                marginTop: 6
                            }}
                                onClick={handleWarehouseOrgchart}
                                onMouseEnter={e => Object.assign(e.currentTarget.style, hoverStyle)}
                                onMouseLeave={e => Object.assign(e.currentTarget.style, cardStyle)}

                            // onMouseEnter={(e) => e.currentTarget.style.background = "#4f46e5"}
                            // onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
                            >
                                <AppstoreOutlined style={{ color: "#3366cc" }} /> {t("warehouseOrgChart")}
                            </div>

                        </div>
                    </Panel>
                </Collapse>
            </div>

            <Suspense
                fallback={<div></div>}
            >
                {tendersOpen &&
                    <ModifyTendersDrawer
                        open={tendersOpen}
                        onClose={() => setTendersOpen(false)}
                    />
                }

                {galleryOpen &&
                    <ModifyGalleryDrawer
                        open={galleryOpen}
                        onClose={() => setGalleryOpen(false)}
                    />
                }



                {managementTeamOpen &&
                    <ManagementTeams
                        open={managementTeamOpen}
                        onClose={() => setManagementTeamOpen(false)}
                    />
                }
            </Suspense>

            {/* sliderimages  */}
            <Modal
                title={
                    <div className="d-flex justify-content-left align-items-center gap-2 me-4">
                        <PictureOutlined
                            style={{
                                fontSize: 22,
                                color: "#2563eb",
                            }}
                        />
                        <span>{t("sliderimages")}</span>
                    </div>
                }
                open={openSliderModal}
                onCancel={() => setOpenSliderModal(false)}
                footer={null}
                centered
                width={650}
            >
                <div className="p-2">
                    {/* Image Grid */}
                    <div className="row g-3">
                        {uploadedImages?.map((image, index) => (
                            <div className="col-6 col-md-4" key={index}>

                                <div
                                    className="position-relative overflow-hidden"
                                    style={{
                                        border: "1px solid #e5e7eb",
                                        borderRadius: "10px",
                                        background: "#f8fafc",
                                    }}
                                >

                                    {/* Image */}
                                    <img
                                        src={image.image_url}
                                        alt={image.title}
                                        style={{
                                            width: "100%",
                                            height: "130px",
                                            objectFit: "cover",
                                            display: "block",
                                        }}
                                    />

                                    {/* View Button */}
                                    <button
                                        type="button"
                                        onClick={() => setPreviewImage(image.image_url)}
                                        className="position-absolute d-flex align-items-center justify-content-center border-0"
                                        style={{
                                            top: "8px",
                                            left: "8px",
                                            width: "32px",
                                            height: "32px",
                                            borderRadius: "50%",
                                            background: "rgba(255,255,255,0.9)",
                                            color: "#0A2158",
                                            cursor: "pointer",
                                            boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                        }}
                                    >
                                        <i className="bi bi-eye-fill"></i>
                                    </button>

                                    {/* Delete Button */}
                                    <button
                                        type="button"
                                        onClick={() => handleDeleteImage(image)}
                                        className="position-absolute d-flex align-items-center justify-content-center border-0"
                                        style={{
                                            top: "8px",
                                            right: "8px",
                                            width: "32px",
                                            height: "32px",
                                            borderRadius: "50%",
                                            background: "rgba(255,255,255,0.9)",
                                            color: "#dc2626",
                                            cursor: "pointer",
                                            boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                        }}
                                    >
                                        <i className="bi bi-trash-fill"></i>
                                    </button>

                                    {/* File Name */}
                                    <div
                                        className="px-2 py-2 text-center"
                                        style={{
                                            fontSize: "12px",
                                            fontWeight: "500",
                                            color: "#374151",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                        }}
                                        title={image.title}
                                    >
                                        {image.title}
                                    </div>

                                </div>

                            </div>
                        ))}

                        {/* Upload Card */}
                        <div className="col-6 col-md-4">
                            <label
                                htmlFor="slider-image-upload"
                                className="d-flex flex-column align-items-center justify-content-center"
                                style={{
                                    height: "172px",
                                    border: "2px dashed #cbd5e1",
                                    borderRadius: "10px",
                                    background: loading ? "#f1f5f9" : "#f8fafc",
                                    cursor: loading ? "not-allowed" : "pointer",
                                    opacity: loading ? 0.7 : 1,
                                    transition: "all 0.2s ease",
                                }}
                            >
                                {loading ? (
                                    <>
                                        <div
                                            className="spinner-border mb-2"
                                            style={{
                                                width: "32px",
                                                height: "32px",
                                                color: "#1d4ed8",
                                            }}
                                            role="status"
                                        >
                                            <span className="visually-hidden">
                                                {t("uploading")}
                                            </span>
                                        </div>

                                        <span
                                            className="fw-semibold"
                                            style={{
                                                color: "#1d4ed8",
                                                fontSize: "14px",
                                            }}
                                        >
                                            {t("uploading")}
                                        </span>
                                    </>
                                ) : (
                                    <>
                                        <div
                                            className="d-flex align-items-center justify-content-center mb-2"
                                            style={{
                                                width: "45px",
                                                height: "45px",
                                                borderRadius: "50%",
                                                background: "#eaf1ff",
                                                color: "#1d4ed8",
                                                fontSize: "22px",
                                            }}
                                        >
                                            <i className="bi bi-plus-lg"></i>
                                        </div>

                                        <span
                                            className="fw-semibold text-center"
                                            style={{
                                                color: "#1d4ed8",
                                                fontSize: "14px",
                                            }}
                                        >
                                            {t("uploadimages")}
                                        </span>

                                        <span
                                            className="text-muted"
                                            style={{ fontSize: "11px" }}
                                        >
                                            {t("imgtype")}
                                        </span>
                                    </>
                                )}

                                <input
                                    id="slider-image-upload"
                                    type="file"
                                    accept="image/png,image/jpeg,image/jpg"
                                    multiple
                                    hidden
                                    disabled={loading}
                                    onChange={handleImageUpload}
                                />
                            </label>
                        </div>
                    </div>
                </div>

                {/* Image Preview */}
                <Modal
                    open={!!previewImage}
                    footer={null}
                    onCancel={() => setPreviewImage(null)}
                    centered
                    width={800}
                >
                    <img
                        src={previewImage}
                        alt="Preview"
                        style={{
                            width: "100%",
                            maxHeight: "75vh",
                            objectFit: "contain",
                            borderRadius: "8px",
                        }}
                    />
                </Modal>

            </Modal>

            {/* announcement  */}
            <Modal
                title={
                    <div className="d-flex justify-content-between align-items-center me-4">
                        <span>📢 {t("announcements")}</span>

                        <button
                            className="btn btn-sm btn-primary"
                            onClick={handleAdd}
                            title={data.length >= 5 ? t("maxLimit") : ""}
                            style={{
                                cursor: data.length >= 5 ? "not-allowed" : "pointer",
                                opacity: data.length >= 5 ? 1 : 1
                            }}
                        >
                            + {t("add")}
                        </button>
                    </div>
                }
                open={openModal}
                onCancel={() => setOpenModal(false)}
                footer={null}
                centered
                width={650}
            >
                <List
                    itemLayout="vertical"
                    dataSource={data}
                    renderItem={(item, index) => (
                        <List.Item
                            className="mb-3"
                            style={{
                                borderRadius: 12,
                                padding: "15px",
                                background: "#f8fafc",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
                            }}
                        >
                            <div className="d-flex justify-content-between align-items-start">

                                {/* Content */}
                                <div className="d-flex align-items-center gap-3 w-100">
                                    <div>{index + 1}.</div>

                                    <div style={{ width: "100%" }}>
                                        {editIndex === index ? (
                                            <>
                                                <textarea
                                                    className="form-control mb-2"
                                                    rows={2}
                                                    placeholder={t("tamilText")}
                                                    value={editData.ta_news}
                                                    onChange={(e) =>
                                                        setEditData({ ...editData, ta_news: e.target.value })
                                                    }
                                                />

                                                <textarea
                                                    className="form-control"
                                                    rows={2}
                                                    placeholder={t("englishText")}
                                                    value={editData.en_news}
                                                    onChange={(e) =>
                                                        setEditData({ ...editData, en_news: e.target.value })
                                                    }
                                                />
                                            </>
                                        ) : (
                                            <>
                                                <div style={{ fontWeight: 600 }}>
                                                    {item.ta_news}
                                                </div>
                                                <div style={{ color: "#6b7280", marginTop: 4 }}>
                                                    {item.en_news}
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>

                                {/* Actions */}
                                <div className="d-flex gap-2 ms-2">
                                    {editIndex === index ? (
                                        <>
                                            <button
                                                className="btn btn-sm btn-success"
                                                onClick={handleSave}
                                            >
                                                {t("save")}
                                            </button>
                                            <button
                                                className="btn btn-sm btn-secondary"
                                                onClick={handleCancel}
                                            >
                                                {t("cancel")}
                                            </button>
                                        </>
                                    ) : (
                                        <>
                                            <button
                                                className="btn btn-sm btn-outline-primary"
                                                onClick={() => handleEdit(item, index)}
                                            >
                                                {t("edit")}
                                            </button>
                                            <button
                                                className="btn btn-sm btn-outline-danger"
                                                onClick={() => handleDelete(item.id)}
                                            >
                                                {t("delete")}
                                            </button>
                                        </>
                                    )}
                                </div>
                            </div>
                        </List.Item>
                    )}
                />

                {isAdding && (
                    <div className="mb-3 p-3" style={{
                        borderRadius: 10,
                        background: "#eef2ff"
                    }}>
                        <textarea
                            className="form-control mb-2"
                            placeholder={t("tamilText")}
                            value={editData.ta_news}
                            onChange={(e) =>
                                setEditData({ ...editData, ta_news: e.target.value })
                            }
                        />
                        <textarea
                            className="form-control mb-2"
                            placeholder={t("englishText")}
                            value={editData.en_news}
                            onChange={(e) =>
                                setEditData({ ...editData, en_news: e.target.value })
                            }
                        />
                        <div className="d-flex gap-2">
                            <button className="btn btn-sm btn-success" onClick={handleSave}>
                                {t("save")}
                            </button>
                            <button className="btn btn-sm btn-secondary" onClick={handleCancel}>
                                {t("cancel")}
                            </button>
                        </div>
                    </div>
                )}
            </Modal>

        </Drawer >
    );
};

export default MoreDrawer;